import React, { useCallback, useEffect, useRef, useState } from "react";

import axios from "axios";

import CardWrapper from "./Cards/Wrapper";
import CardType from "./CardType";

import { IFeedEntry } from "../store/FeedEntry";
import GlobalFeed from "../store/GlobalFeed";
import { get } from "http";

const HOSTNAME = process.env.REACT_APP_LRNER_API_URL || "https://api.lrner.io";
console.log(
  `Setting hostname to: ${HOSTNAME} because REACT_APP_LRNER_API_URL is ${process.env.REACT_APP_LRNER_API_URL}`
);

const INFINITE_SCROLL_TRIGGER_SCREEN_PERCENTAGE = 0.8;

interface ICardListProps {
  tag: string;
  creator?: string;
  loading: boolean;
  setCategory: Function;
  setLoading: Function;
  feed: string;
}

export default function CardList({
  creator,
  tag,
  loading,
  setLoading,
  feed,
}: ICardListProps) {
  const loader = useRef(null);

  let feedKey = feed || tag || "default";
  console.log(`feedKey: ${feedKey}`);

  let defaultFeedState: any[] = [];

  const [error, setError] = useState(null);

  const [feeds, setFeeds]: [
    feeds: Record<string, IFeedEntry[]>,
    setFeeds: Function
  ] = useState({
    default: defaultFeedState,
  });

  if (feeds[feedKey] === undefined) {
    feeds[feedKey] = [];
  }

  const setFeed = (tag: string, data: IFeedEntry[]) => {
    let _feeds = feeds;
    feeds[tag] = data;
    setFeeds(_feeds);
  };

  // const [loadedVids, setLoadedVids] = useState([] as number[]);

  const handleScroll = () => {
    console.log("Scrolling...");
    if (
      window.innerHeight + document.documentElement.scrollTop <
        document.documentElement.offsetHeight *
          INFINITE_SCROLL_TRIGGER_SCREEN_PERCENTAGE ||
      loading
    ) {
      return;
    }
    console.log(
      `Running OlderFeed because ${
        window.innerHeight + document.documentElement.scrollTop
      } > ${
        document.documentElement.offsetHeight *
        INFINITE_SCROLL_TRIGGER_SCREEN_PERCENTAGE
      }`
    );
    feedLength = getFeedLength(feeds, feedKey);
    olderFeed(feedLength - 2);
  };

  const handleObserver = useCallback((entries: any) => {
    const target = entries[0];
    if (target.isIntersecting) {
      handleScroll();
    }
  }, []);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "20px",
      threshold: 0,
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (loader.current) observer.observe(loader.current);
  }, [handleObserver]);

  const olderFeed = async (loadNewVidsAt: number) => {
    // if (loadedVids.includes(loadNewVidsAt)) return;
    // const newLoadedVids = loadedVids.concat(loadNewVidsAt);
    // setLoadedVids(newLoadedVids);
    // console.log(`Loaded vids: ${newLoadedVids}`);
    if (loading) return;
    setLoading(true);

    const latestFeedEntry: IFeedEntry =
      feeds[feedKey][feeds[feedKey].length - 1];

    if (!latestFeedEntry) {
      return;
    }
    const latestFeedEntryId = latestFeedEntry.id;

    let url = `${HOSTNAME}/global_feeds/${latestFeedEntryId}.json`;
    if (feed) {
      url = url + "?feed=" + feed;
    }
    try {
      const globalFeed: any = await axios.get(url);
      if (globalFeed.data && (globalFeed.data as IFeedEntry[]).length > 0) {
        let concatenatedFeed = feeds[feedKey].concat(
          globalFeed.data as IFeedEntry[]
        );
        if (concatenatedFeed.length < loadNewVidsAt + 12) {
          console.log(
            `Setting feed because ${concatenatedFeed.length} < ${
              loadNewVidsAt + 12
            }`
          );
          setFeed(tag, concatenatedFeed);
        }
      }
    } catch (e: any) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  const taggedFeed = async (tag: string) => {
    const url = `${HOSTNAME}/global_feeds?tag=${tag}`;
    const globalFeed: any = axios.get(url);

    if (globalFeed.data && (globalFeed.data as IFeedEntry[]).length > 0) {
      setFeed(feedKey, feeds[feedKey].concat(globalFeed.data as IFeedEntry[]));
    }
  };

  const fetchData = async (tagInput: string) => {
    console.log("fetchData");
    const globalFeed = new GlobalFeed();
    let filteredGlobalFeed = await globalFeed
      .feed(feed)
      .fetch(creator || "", tag, feeds)
      .catch(console.error);
    setFeed(feedKey, feeds[feedKey].concat(filteredGlobalFeed as IFeedEntry[])); // TODO: don't concat duplicates, and also ensure scroll to load works
    setLoading(false);
  };

  useEffect(() => { 
    if (loading) return;
    setLoading(true);
    fetchData(tag).catch(console.error);
  }, [tag]);

  const getFeedLength = (
    feeds: Record<string, IFeedEntry[]>,
    feedKey: string
  ) => {
    return feeds[feedKey] ? feeds[feedKey].length + 1 : 0;
  };

  let feedLength = getFeedLength(feeds, feedKey);

  const [hiddenCards, setHiddenCards] = useState(
    new Array(feedLength).fill(false) as boolean[]
  );

  const hideEntry = (index: number) => {
    const hiddenCardsTemp = hiddenCards;
    hiddenCardsTemp[index] = true;
    setHiddenCards(hiddenCardsTemp);
  };

  return (
    <React.Fragment>
      {feeds[feedKey] &&
        feeds[feedKey].map((feedEntry: IFeedEntry, id: number) => {
          if (
            feedEntry &&
            feedEntry.images.filter(
              (img: string | undefined) => img !== undefined
            ).length > 0
          ) {
            return (
              <CardWrapper
                key={id}
                index={id + 1}
                hidden={hiddenCards[id + 1]}
                lastFeedIndex={feedLength - 2}
                feedEntry={feedEntry}
                olderFeed={olderFeed}
                taggedFeed={taggedFeed}
              >
                <CardType
                  height="80vh"
                  feedEntry={feedEntry}
                  hideEntry={hideEntry}
                  index={id + 1}
                />
              </CardWrapper>
            );
          } else {
            return <div></div>;
          }
        })}
      {loading && (
        <div>
          <div className="text-6xl content-cente mb-4 mt-1"> Loading...</div>
        </div>
      )}
      {error && (
        <div>
          <div className="text-6xl text-red-700 content-center mb-4 mt-1">
            Errored
          </div>
        </div>
      )}
      <div ref={loader} />
    </React.Fragment>
  );
}
